import PagedResponse from "@/types/sv-data/PagedResponse";
import { CancelTokenSource } from "axios";

export interface AlarmPointState {
	selectedArea: any,
	displayResponseId: number | null,
	responses: any[],
	alarmPointManagerOpen: boolean,
	cancelTokenSource: CancelTokenSource | null,
	selectedResponse: any,
	disableAutomaticLoad: boolean
}

export enum OnTestScheduleType {
	ForPeriod = 1,
	UntilDate = 2
}

export class OnTestRequest {
	groupId?: number;
	responseId?: number;

	hours: number | null;
	minutes: number | null;
	date: Date | null;
	time?: string;
	scheduleType: number;
	auditMode: boolean;
	onTestNote: string;
}

export class AlarmPointsResponse {
	responseID: number;
	title: string;
	groupID?: number | null;
	armed: boolean;
	toggleArmAt: Date | null;
	maskDurationLimit?: number | null;
	disarmReasonTitle: string;
	onTest: boolean;
	onTestUntil: Date | null;
	onTestNote: string;
	extraValue: string;
	deviceTitle: string;
	onTestUntilColumnText?: string | null;
	maskedUntilColumnText?: string | null;
}

export interface AlarmPointHistoryItem {
	created: string;
	eventId: number;
	details: string;
	eventOutcome: string;
	eventRecordId: number;
}

export interface AlarmPointHistoryPagedResponse extends PagedResponse {
	data: AlarmPointHistoryItem[];
}
